import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    VStack,
} from '@chakra-ui/react';
import DropDown from 'components/forms/new/formikFormFields/DropDown';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import walkthroughIds from '../../../walkthroughIds';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';

const ZoomVisibleScopeField = ({ field, form, options, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    const error =
        form.errors.visibleScope && form.touched.visibleScope
            ? form.errors.visibleScope
            : '';
    const visibleScopeOptions = (options || []).map((opt) => ({
        id: opt.value,
        name: opt.label,
    }));
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!error}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Visible Scope{' '}
                        <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Select the visibility scope for this Zoom profile.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            alignItems: 'flex-start',
                            paddingTop: '15px',
                        }}>
                        <VStack width="100%" alignItems="normal">
                            <DropDown
                                field={field}
                                form={form}
                                name="visibleScope"
                                data={visibleScopeOptions}
                                shownValue="name"
                                placeholder="Select Visible Scope"
                                walkthroughId={
                                    walkthroughIds.serviceProfiles
                                        ?.ufVisibleScopeInput
                                }
                                darkMode={darkMode}
                                width="100%"
                                noPadding
                                handleSelectChange={(item) =>
                                    form.setFieldValue(
                                        'visibleScope',
                                        item?.id ?? '',
                                    )
                                }
                            />

                            <Text
                                color="red.500"
                                fontSize="xs"
                                mt={1}
                                textAlign="right">
                                {error}
                            </Text>
                        </VStack>
                    </Box>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Select the visibility scope for this Zoom profile."
                        ariaLabel="zoom-visible-scope-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default ZoomVisibleScopeField;
